export enum BranchCodeEnum {
  AirForce = 'F',
  SpaceForce = 'H',
  CoastGuard = 'C',
  Army = 'A',
  MarineCorps = 'M',
  Navy = 'N',
}
